!function () {
    var _ = {};

    var instances = {};

    var data_animation = (function () {
        var queue = [];
        var queueInProgress = false;
        var maxWorkInterval = 30; // ms
        var batchMultiplier = 0.2;

        var animate = function (batch, type) {
            if (type === 'show') {
                let $batch = $('').add(batch.map(function (e) { return e.element[0]; }));
                $batch.removeClass('removed hidden').addClass('added');
                animate($batch.parent().children().filter(':not(.removed)'), 'update');
            } else if (type === 'hide') {
                let $batch = $('').add(batch.map(function (e) { return e.element[0]; }));
                $batch.removeClass('added odd even').addClass('removed');
                setTimeout(function () {
                    $batch.addClass('hidden');
                }, 600);
                animate($batch.parent().children().filter(':not(.removed)'), 'update');
            } else if (type === 'update') {
                // even/odd is zero indexed
                batch.filter(':odd').removeClass('odd').addClass('even');
                batch.filter(':even').removeClass('even').addClass('odd');
            } else if (type === 'append') {
                // what to do?
            }
        };

        var startQueue = function () {
            if (!queueInProgress) {
                queueInProgress = true;
                setTimeout(doWork, 1);
                //console.dir(new Date());
                //console.log('queue started');
            }
        };

        var stopQueue = function (flush) {
            queueInProgress = false;
            //console.dir(new Date());
            //console.log('queue stopped');

            if (flush === true) {
                queue = [];
            }
        };

        var doWork = function () {
            if (queueInProgress) {
                //console.log('Queue: ' + queue.length);
                try {
                    if (queue && queue.length > 0) {
                        var batch = [];

                        batch.push(queue.shift());
                        var index = 0;
                        var type = batch[index].type;
                        var batchSize = queue.length * batchMultiplier;

                        while (batch.length < batchSize && index < queue.length - 1) {
                            if (queue[index].type === type) {
                                batch.push(queue.splice(index, 1)[0]);
                            } else {
                                index++;
                            }
                        }

                        animate(batch, type);
                        var timeout = Math.max((Math.pow(0.98, queue.length) * maxWorkInterval), 1);
                        setTimeout(doWork, timeout);
                    } else {
                        stopQueue();
                    }
                } catch (err) {
                    //console.dir(err);
                    stopQueue();
                }
            }
        };

        return {
            startQueue: startQueue,
            stopQueue: stopQueue,
            toggleElement: function (element, visible, runQueue) {
                queue.push({
                    element: element,
                    type: visible ? 'show' : 'hide'
                });

                if (runQueue !== false) {
                    startQueue();
                }
            },
            update: function (table) {
                animate($(table).find('tbody tr'), 'update');
            },
            append: function (target, element) {
                queue.push({
                    element: element,
                    type: visible ? 'show' : 'hide'
                });
            }
        };
    })();

    _.init = function (id, _columns, _header, _rows, _empty) {
        var emptyRow = $('<tr class="emptyRow"><td colspan="' + _columns.length + '">' + _empty + '</td></tr>');
        var _instance = null;
        if (!instances[id]) {
            _instance = instances[id] = {
                columns: _columns,
                header: _header,
                rows: _rows,
                empty: emptyRow,
                table: $('#' + id)
            };
        } else {
            _instance = $.extend(instances[id], {
                columns: _columns,
                header: _header,
                rows: _rows,
                empty: emptyRow,
                table: $('#' + id)
            });
        }

        for (var i = 0; i < _rows.length; i++) {
            var row = _rows[i];
            row.element = $('#' + _rows[i].ID);
            row.currentIndex = i;
        }

        _instance.table.off('click', 'thead th.sortable:not(.unavailable)').on('click', 'thead th.sortable:not(.unavailable)', function () {
            var self = $(this);
            var direction = self.data('sort-direction');
            var newDirection = '';
            var down = 'down', up = 'up';

            if (direction.length === 0 || direction === up) {
                newDirection = down;
            } else if (direction === down) {
                newDirection = up;
            }

            var ths = _instance.table.find('thead th:nth-child(' + (self.index()+1) +')');
            ths.data('sort-direction', newDirection);
            ths.attr('data-sort-direction', newDirection);
            ths.find('.datalist-sort-arrow').removeClass(direction).addClass(newDirection);

            $(ths).siblings('.sortable').each(function () {
                var _that = $(this);
                _that.data('sort-direction', '');
                _that.attr('data-sort-direction', '');
                _that.find('.datalist-sort-arrow').removeClass('down').removeClass('up');
            });

            setTimeout(function () { doSort(id, self.data('col'), self.data('data-type'), newDirection); }, 1);
        });

        $('article').on('scroll load resize', (function () {
            let oldTop = null;
            let table_header = _instance.table.find('thead');
            let table_header_clone = table_header
                .clone(true)
                .addClass('clone sticky hidden')
                .insertAfter(table_header);

            table_header.find('th').each(function (k, v) {
                table_header_clone.find('th').eq(k).css({ width: $(v).outerWidth(false) });
            });

            return function (event) {
                let last_row_position = gb.ui.position(_instance.table.find('tbody tr:last-child'));
                if (!last_row_position.inside.top) {
                    oldTop = true;
                    table_header_clone.toggleClass('hidden', true);
                    return;
                }

                let position = gb.ui.position(table_header);
                if (position.inside.top !== oldTop) {
                    oldTop = position.inside.top;

                    table_header_clone.toggleClass('hidden', position.inside.top);
                }
            };
        })());
    };

    _.filter = function (datalistID, filterID, column, value, defer) {
        var newFilter = {
            col: column,
            val: value
        };

        var initFilters = function () {
            instances[datalistID].filters = {};
            instances[datalistID].filters[filterID] = newFilter;
        };

        if (!instances[datalistID]) {
            instances[datalistID] = {};
            initFilters();
        } else {
            if (!instances[datalistID].filters) {
                initFilters();
            } else {
                if (!instances[datalistID].filters[filterID]) {
                    instances[datalistID].filters[filterID] = newFilter;
                } else {
                    var filter = instances[datalistID].filters[filterID];
                    $.extend(true, filter, newFilter);
                }
            }
        }
        !defer && doFilter(datalistID);
    };

    var doSort = function (datalistID, column, type, direction) {
        var _instance = instances[datalistID];
        var sorted_rows = [];

        for (var row_key in _instance.rows) {
            var row = _instance.rows[row_key];
            var own_data = row.Cells[column].Data;

            var sorted_index = binarySearch(sorted_rows, own_data, column, type);

            sorted_rows.splice(sorted_index, 0, row);
            row.currentIndex = row.element.index();
        }

        var $fragment = $(document.createDocumentFragment());

        if (direction === 'up') {
            sorted_rows = sorted_rows.reverse();
        }

        var $tbody = _instance.table.find('tbody').detach().empty();

        for (var i = 0; i < sorted_rows.length; i++) {
            var sorted_row = sorted_rows[i];

            //if (i < sorted_row.currentIndex) { // moved up
            //    sorted_row.element.removeClass('sorted-down').addClass('sorted-up');
            //} else if (i > sorted_row.currentIndex) { // morved down
            //    sorted_row.element.removeClass('sorted-up').addClass('sorted-down');
            //} else {
            //    sorted_row.element.removeClass('sorted-down sorted-up');
            //}
            sorted_row.currentIndex = i;
            $fragment.append(sorted_row.element);
        }

        $tbody.append($fragment);
        _instance.table.append($tbody);

        data_animation.update(_instance.table);
    };

    var binarySearch = function (array, item, column, type) {
        var min_index = 0;
        var max_index = array.length - 1;
        var current_index;
        var current_item;

        while (min_index <= max_index) {
            current_index = (max_index + min_index) >> 1;
            current_item = array[current_index].Cells[column].Data;

            var cmp = compare(item, current_item, type);

            if (cmp > 0) {
                min_index = current_index + 1;
            } else if (cmp < 0) {
                max_index = current_index - 1;
            } else {
                return current_index;
            }
        }

        return min_index | 0;
    }

    var compare = function (a, b, type) {
        if (b === null || typeof b === 'undefined' || b === "@null") {
            return -1;
        }

        if (a === null || typeof a === 'undefined' || a === "@null") {
            return 1;
        }

        switch (type) {
            case 'Text':
            case 'Money':
            case 'Number':
            case 'Date':
            case 'DateTime':
            case 'Time':
            default:
                return (a < b ? -1 : (a > b ? 1 : 0));
        }
    }

    var doFilter = function (datalistID) {
        var _instance = instances[datalistID];
        var _filters = _instance.filters;

        var has_filter_value = false;
        for (var filter_key in _filters) {
            if (_filters[filter_key].val.length) {
                has_filter_value = true;
                break;
            }
        }

        if (has_filter_value) {
            for (var key in _filters) {
                var filter = _filters[key];

                var moveToHidden = [];

                if (filter.val.length > 0) {
                    if (filter.col === 'All') {
                        for (let rowKey in _instance.rows) {
                            let row = _instance.rows[rowKey];
                            let cells = row.Cells;
                            let hasMatch = false;

                            for (var cellKey in cells) {
                                var cell = cells[cellKey];
                                if (matchFilter(cell, filter.val)) {
                                    hasMatch = true;
                                    break;
                                }
                            }

                            if ((hasMatch && !row.Visible) ||
                                (!hasMatch && row.Visible)) {
                                row.Visible = !row.Visible;
                                data_animation.toggleElement(row.element, hasMatch, true);
                            }
                        }
                    } else {
                        for (let rowKey in _instance.rows) {
                            let row = _instance.rows[rowKey];
                            let cell = row.Cells[filter.col];
                            let hasMatch = matchFilter(cell, filter.val);

                            if ((hasMatch && !row.Visible) ||
                                (!hasMatch && row.Visible)) {
                                row.Visible = !row.Visible;
                                data_animation.toggleElement(row.element, hasMatch, true);
                            }
                        }
                    }
                }
            }
        } else {
            var removed_rows = _instance.rows.filter(function (row) { return !row.Visible });

            for (let key in removed_rows) {
                let row = removed_rows[key];
                data_animation.toggleElement(row.element, (row.Visible = true), true);
            }
        }
    };

    var matchFilter = function (cell, filter_value) {
        return (!gb.linq(cell.DataType).any([4, 6]) && cell.Data !== null &&
            cell.Data.toString().toLowerCase().indexOf(filter_value.toLowerCase()) > -1);
    };

    window.datalist = _;
}();